// 服務條款內容（4 語言）
// 1.0 無 Terms 頁面，本文件為新撰寫的基礎服務條款，需法務確認後修訂。

const zhTW = `
<h6>條款的接受</h6>
<p>歡迎使用 iPastBook（以下簡稱「本服務」）。本服務由 iPastBook 團隊（以下簡稱「我們」）營運。當您註冊賬戶、瀏覽網站、製作或購買書籍時，即表示您已閱讀、理解並同意受本《服務條款》之約束。若您不同意本條款的任何部分，請停止使用本服務。</p>

<h6>服務內容</h6>
<p>iPastBook 提供將您在 Facebook、Instagram、X 等社交平台上的內容自動排版為電子書，並可選擇印刷成紙質書寄送至您指定地址的服務。具體服務內容、規格及價格以網站當期顯示為準，我們有權隨時調整、暫停或終止部分或全部服務。</p>

<h6>賬戶與授權</h6>
<ol>
  <li>您可透過 Facebook、Google 等第三方平台帳號登入本服務，授權範圍以登入時平台彈出的授權頁為準。</li>
  <li>您應對自己的帳號活動負責，包括但不限於授權內容、訂單、支付資訊等。</li>
  <li>若您發現帳號遭未授權使用，請立即通知我們。</li>
</ol>

<h6>內容與知識產權</h6>
<ol>
  <li>您透過本服務上傳、授權獲取的所有原始內容（文字、圖片、視訊等），其著作權歸您本人或原始發布者所有。</li>
  <li>您保證所提交內容不侵犯任何第三方的合法權益，包括著作權、肖像權、隱私權等。如因您提交的內容引起的任何爭議或法律責任，由您自行承擔。</li>
  <li>本服務的網站設計、模板樣式、排版引擎、品牌標識等知識產權歸 iPastBook 所有，未經書面授權不得複製、改作或商業利用。</li>
</ol>

<h6>訂單與支付</h6>
<ol>
  <li>所有商品價格以下單時網站顯示為準。下單後，我們將透過 Stripe、PayPal 等第三方支付通道收取款項。</li>
  <li>因紙質書屬個性化定制商品，一經支付並進入印刷階段即無法取消或退貨，請務必於下單前仔細校對內容。</li>
  <li>如因印刷品質問題（缺頁、模糊、裝訂錯誤等）導致實物與預覽嚴重不符，請於收貨後 7 天內提供照片證據聯繫客服，我們將安排重印或退款。</li>
</ol>

<h6>物流與寄送</h6>
<ol>
  <li>標準寄送週期為下單後 7–14 個工作日（含印刷與物流）。訂單高峰期可能延長，請耐心等待。</li>
  <li>您應提供準確的收貨資訊，因地址錯誤、無人簽收等個人原因造成的退件、丟件或重寄費用，由您承擔。</li>
  <li>跨境寄送可能產生關稅或進口稅，由收件人自行承擔。</li>
</ol>

<h6>使用限制</h6>
<p>您同意不會利用本服務從事以下行為：</p>
<ol>
  <li>製作、傳播違反當地法律法規或公序良俗的內容；</li>
  <li>侵犯他人肖像權、著作權、隱私權等合法權益；</li>
  <li>對本服務系統進行逆向工程、爬蟲抓取或其他干擾、破壞性操作；</li>
  <li>利用本服務進行任何形式的商業轉售、未經授權的二次分發。</li>
</ol>

<h6>免責聲明</h6>
<p>在法律允許的最大範圍內：</p>
<ol>
  <li>本服務按「現狀」提供，我們不對服務的可用性、準確性或滿足您特定用途作出明示或暗示的保證；</li>
  <li>我們對因不可抗力（如自然災害、戰爭、政府管制、第三方平台政策變更等）導致的服務中斷或內容遺失不承擔責任；</li>
  <li>我們對您與第三方（包括支付通道、物流商、社交平台）之間的爭議不承擔責任。</li>
</ol>

<h6>條款的變更</h6>
<p>我們可能會適時更新本《服務條款》。如有重大變更，將於網站顯著位置公告。您於變更生效後繼續使用本服務即視為接受新條款。</p>

<h6>聯繫我們</h6>
<p>如對本《服務條款》有任何疑問，請通過 <a href="https://m.me/iPastBookBot">m.me/iPastBookBot</a> 聯繫我們。</p>
`

const zhCN = `
<h6>条款的接受</h6>
<p>欢迎使用 iPastBook（以下简称"本服务"）。本服务由 iPastBook 团队（以下简称"我们"）运营。当您注册账户、浏览网站、制作或购买书籍时，即表示您已阅读、理解并同意受本《服务条款》之约束。若您不同意本条款的任何部分，请停止使用本服务。</p>

<h6>服务内容</h6>
<p>iPastBook 提供将您在 Facebook、Instagram、X 等社交平台上的内容自动排版为电子书，并可选择印刷成纸质书寄送至您指定地址的服务。具体服务内容、规格及价格以网站当期显示为准，我们有权随时调整、暂停或终止部分或全部服务。</p>

<h6>账户与授权</h6>
<ol>
  <li>您可透过 Facebook、Google 等第三方平台帐号登入本服务，授权范围以登入时平台弹出的授权页为准。</li>
  <li>您应对自己的帐号活动负责，包括但不限于授权内容、订单、支付信息等。</li>
  <li>若您发现帐号遭未授权使用，请立即通知我们。</li>
</ol>

<h6>内容与知识产权</h6>
<ol>
  <li>您透过本服务上传、授权获取的所有原始内容（文字、图片、视频等），其著作权归您本人或原始发布者所有。</li>
  <li>您保证所提交内容不侵犯任何第三方的合法权益，包括著作权、肖像权、隐私权等。如因您提交的内容引起的任何争议或法律责任，由您自行承担。</li>
  <li>本服务的网站设计、模板样式、排版引擎、品牌标识等知识产权归 iPastBook 所有，未经书面授权不得复制、改作或商业利用。</li>
</ol>

<h6>订单与支付</h6>
<ol>
  <li>所有商品价格以下单时网站显示为准。下单后，我们将透过 Stripe、PayPal 等第三方支付通道收取款项。</li>
  <li>因纸质书属个性化定制商品，一经支付并进入印刷阶段即无法取消或退货，请务必于下单前仔细校对内容。</li>
  <li>如因印刷品质问题（缺页、模糊、装订错误等）导致实物与预览严重不符，请于收货后 7 天内提供照片证据联系客服，我们将安排重印或退款。</li>
</ol>

<h6>物流与寄送</h6>
<ol>
  <li>标准寄送周期为下单后 7–14 个工作日（含印刷与物流）。订单高峰期可能延长，请耐心等待。</li>
  <li>您应提供准确的收货信息，因地址错误、无人签收等个人原因造成的退件、丢件或重寄费用，由您承担。</li>
  <li>跨境寄送可能产生关税或进口税，由收件人自行承担。</li>
</ol>

<h6>使用限制</h6>
<p>您同意不会利用本服务从事以下行为：</p>
<ol>
  <li>制作、传播违反当地法律法规或公序良俗的内容；</li>
  <li>侵犯他人肖像权、著作权、隐私权等合法权益；</li>
  <li>对本服务系统进行逆向工程、爬虫抓取或其他干扰、破坏性操作；</li>
  <li>利用本服务进行任何形式的商业转售、未经授权的二次分发。</li>
</ol>

<h6>免责声明</h6>
<p>在法律允许的最大范围内：</p>
<ol>
  <li>本服务按"现状"提供，我们不对服务的可用性、准确性或满足您特定用途作出明示或暗示的保证；</li>
  <li>我们对因不可抗力（如自然灾害、战争、政府管制、第三方平台政策变更等）导致的服务中断或内容遗失不承担责任；</li>
  <li>我们对您与第三方（包括支付通道、物流商、社交平台）之间的争议不承担责任。</li>
</ol>

<h6>条款的变更</h6>
<p>我们可能会适时更新本《服务条款》。如有重大变更，将于网站显著位置公告。您于变更生效后继续使用本服务即视为接受新条款。</p>

<h6>联系我们</h6>
<p>如对本《服务条款》有任何疑问，请通过 <a href="https://m.me/iPastBookBot">m.me/iPastBookBot</a> 联系我们。</p>
`

const en = `
<h6>Acceptance of Terms</h6>
<p>Welcome to iPastBook (the "Service"), operated by the iPastBook team ("we", "us"). By registering an account, browsing the site, or creating or purchasing a book, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service. If you do not agree with any part of these Terms, please discontinue use of the Service.</p>

<h6>Service Description</h6>
<p>iPastBook automatically typesets your content from Facebook, Instagram, X, and similar social platforms into an e-book, and optionally prints and ships a physical book to your designated address. The exact scope, specifications, and pricing of services are as displayed on the site at the time of order. We reserve the right to modify, suspend, or discontinue any part of the Service at any time.</p>

<h6>Account and Authorization</h6>
<ol>
  <li>You may sign in through third-party platforms such as Facebook or Google. The scope of authorization is defined by the consent screen of the third-party platform.</li>
  <li>You are responsible for activity under your account, including authorizations, orders, and payment information.</li>
  <li>If you discover unauthorized use of your account, please notify us immediately.</li>
</ol>

<h6>Content and Intellectual Property</h6>
<ol>
  <li>All original content (text, images, videos) you upload to or authorize the Service to access remains the copyright of you or its original publisher.</li>
  <li>You represent that your submitted content does not infringe any third party's rights, including copyright, likeness, or privacy. You are solely responsible for any disputes or legal liability arising from your content.</li>
  <li>The Service's website design, templates, typesetting engine, and brand assets are the intellectual property of iPastBook and may not be copied, adapted, or commercially exploited without written permission.</li>
</ol>

<h6>Orders and Payment</h6>
<ol>
  <li>Prices are as displayed on the site at the time of order. Payment is processed through third-party providers such as Stripe and PayPal.</li>
  <li>Because physical books are personalized custom goods, once payment is received and printing has begun, orders cannot be cancelled or refunded. Please proofread your content carefully before placing an order.</li>
  <li>If a printing defect (missing pages, blurry print, binding errors) makes the physical book materially differ from the preview, contact customer service within 7 days of delivery with photo evidence and we will arrange a reprint or refund.</li>
</ol>

<h6>Shipping</h6>
<ol>
  <li>Standard delivery is 7–14 business days from order (including printing and shipping). Peak periods may extend this window.</li>
  <li>You are responsible for providing accurate shipping details. Costs from returns, lost parcels, or reshipment due to incorrect addresses or failed delivery are your responsibility.</li>
  <li>Cross-border shipments may incur duties or import taxes, payable by the recipient.</li>
</ol>

<h6>Acceptable Use</h6>
<p>You agree not to use the Service to:</p>
<ol>
  <li>Create or distribute content that violates local laws or public morals;</li>
  <li>Infringe others' rights, including copyright, likeness, or privacy;</li>
  <li>Reverse-engineer, scrape, or otherwise interfere with or disrupt the Service;</li>
  <li>Resell or redistribute the Service without authorization.</li>
</ol>

<h6>Disclaimer</h6>
<p>To the fullest extent permitted by law:</p>
<ol>
  <li>The Service is provided "as is" without express or implied warranties of availability, accuracy, or fitness for a particular purpose;</li>
  <li>We are not liable for service interruptions or content loss caused by force majeure (natural disasters, war, government action, third-party platform changes, etc.);</li>
  <li>We are not liable for disputes between you and third parties (payment processors, shipping carriers, social platforms).</li>
</ol>

<h6>Changes to These Terms</h6>
<p>We may update these Terms of Service from time to time. Material changes will be announced prominently on the site. Continuing to use the Service after a change takes effect constitutes acceptance of the updated Terms.</p>

<h6>Contact Us</h6>
<p>If you have any questions about these Terms of Service, please contact us at <a href="https://m.me/iPastBookBot">m.me/iPastBookBot</a>.</p>
`

export default {
  'zh-tw': zhTW,
  'zh-hk': zhTW,
  'zh-cn': zhCN,
  en
}
